import Head from 'next/head';

interface SchemaMarkupProps {
  jsonLd?: string;
  id: string; // unique id per schema block
}

export default function SchemaMarkup({ jsonLd, id }: SchemaMarkupProps) {
  if (!jsonLd) return null;

  return (
    <Head>
      <script
        key={`jsonld-schema-${id}`} // unique key per script
        dangerouslySetInnerHTML={{ __html: jsonLd }}
        type='application/ld+json'
      />
    </Head>
  );
}

// import Head from 'next/head';
// import { useRouter } from 'next/router';
// import { useEffect, useState } from 'react';

// interface SchemaMarkupProps {
//   jsonLd?: string; // From Kontent as a string
//   id: string;
// }

// export default function SchemaMarkup({ jsonLd, id }: SchemaMarkupProps) {
//   const router = useRouter();
//   const [structuredData, setStructuredData] = useState<object | null>(null);

//   useEffect(() => {
//     if (!jsonLd) return;

//     try {
//       const parsed = JSON.parse(jsonLd);

//       // Inject current URL if it's missing
//       const withUrl = {
//         ...parsed,
//         url: parsed.url || window.location.href,
//       };

//       setStructuredData(withUrl);
//     } catch (err) {
//       console.error(`Failed to parse JSON-LD for ${id}:`, err);
//     }
//   }, [jsonLd]);

//   if (!structuredData) return null;

//   return (
//     <Head>
//       <script
//         key={`jsonld-schema-${id}`}
//         type='application/ld+json'
//         dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
//       />
//     </Head>
//   );
// }
